<template>
  <div class="searchForm">
    <!-- <tabs
      :booking-data="bookingData"
      :round-trip="roundTrip"
      @click-round-trip="setRoundTrip"
    ></tabs> -->
    <form
      autocomplete="off"
      @keypress.enter.prevent=""
      @submit.prevent=""
      class="searchForm__form"
    >
      <div class="searchForm__flightType">
        <component :is="flightTypeComponent"
          v-model="flightTypeSelected"
          v-show="!showSimpleForm && !isMulticity"
          :options="[
            { name: 'one_way', label: 'one_way', show: bookingData.oneWay },
            { name: 'round_trip', label: 'round_trip', show: bookingData.roundTrip },
            { name: 'multicity', label: 'multicity_journey', show: showMulticityFlow }
          ]"
          @change="onFlightTypeChange"
        >
        </component>
      </div>
      <country-settings
        v-show="!showSimpleForm && !isMulticity"
        :country-settings="countrySettingsFiltered"
        v-model="countrySetting"
        :fixedPos="fixedPos"
        @input="destinationOriginOrCountrySettingChange"
      ></country-settings>
      <residents
        v-if="checkApiElegibility && !isMulticity"
        @residentOrNumerousFamilyChange="setResidentNumerousFamilyData"
        :residentData="residentData"
        :elegibilityValues="elegibilityValues"
      ></residents>
      <promo-code
        v-show="!showSimpleForm && !isMulticity"
        v-if="bookingData.promo.enable"
        :booking-data="bookingData"
        :value="promoCodeValue"
        @addPromoCode="(val) => { this.promoCodeValue = val }"
      >
      </promo-code>
      <slot name="action-button"></slot>
      <span class="--void"></span>
      <span v-if="showTitles && !isMulticity"
            class="searchForm__subtitle --OD"
      >
        {{ $t('widget_where_travel') }}
      </span>
      <span v-if="showTitles && !isMulticity"
            class="searchForm__subtitle --date"
      >
        {{ $t('widget_when_travel') }}
      </span>
      <span v-if="showTitles && !isMulticity"
            class="searchForm__subtitle --pax"
      >
        {{ $t('widget_who_travel') }}
      </span>
      <div class="searchForm__OD" v-if="!isMulticity">
        <div class="searchForm__ODContainer">
          <autocomplete-airport
            v-model="origin"
            name="origin"
            :label="$t('origin')"
            icon-class="fas fa-plane"
            :full-list="true"
            :airports="getOriginAirports"
            :display="displayTarget"
            ref="origin"
            class="--origin"
            :show-input-label="showInputLabels"
            @input="destinationOriginOrCountrySettingChange"
          ></autocomplete-airport>
          <autocomplete-airport
            v-model="destination"
            :label="$t('destination')"
            name="destination"
            icon-class="fas fa-map-marker-alt"
            :airports="getDestinationAirports"
            :full-list="true"
            :display="displayTarget"
            @search-dates="getDatesAvailable"
            ref="destination"
            :show-input-label="showInputLabels"
            @input="destinationOriginOrCountrySettingChange"
          ></autocomplete-airport>
        </div>
      </div>
      <div class="searchForm__datepicker" v-if="!isMulticity" >
        <datepicker-controller
          :isRoundTrip="isRoundTrip"
          :isDoubleDatepicker="isDoubleDatepicker"
          ref="datepicker"
          :dates="dates"
          :initial-value="dateRange"
          v-model="dateRange"
          :show-input-label="showInputLabels"
          :open-date-picker="autoOpenFirstDatePicker"
          @changeAutoOpenDatepicker="(val) => { this.autoOpenFirstDatePicker = val }"
          :show-fares="showFares"
          :fares="fares"
          :currency="currency"
        >
        </datepicker-controller>
      </div>
      <div class="searchForm__paxs" v-if="!isMulticity"
            :class="[{'--paxsSelect': passengerComponent === 'passengers-select' }]"
        >
        <component
          :is="passengerComponent"
          :cabins="bookingData.cabin"
          :passengers="bookingData.passengers"
          :preSelected="prePassengersSelected"
          v-model="passengers"
          :key="`${mutationCount}passengers`"
          :show-input-label="showInputLabels"
        >
        </component>
      </div>
      <div class="searchForm__searchBtn"
        :class="{'--formLabeled': showInputLabels }"
      >
        <button
          tabindex="5"
          id="search_button"
          class="btn btn-primary"
          @click="submit"
          :disabled="errors.any()"
        >
          <i v-if="searchIcon" :class="searchIcon" />
          {{ $t('search') }}
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import FlightType from './FlightType.vue'
import FlightTypeRadio from './FlightTypeRadio'
import AutocompleteAirport from './AutocompleteAirport'
import CountrySettings from './CountrySettings'
import PassengersSelect from './PassengersSelect'
import Passengers from './Passengers'
import Residents from './Residents'
import PromoCode from './PromoCode'
// import Tabs from './Tabs'
import DatepickerController from './DatepickerController'
import axios from 'axios'
import { pos } from './pos.js'
import moment from 'moment'
import { get, debounce } from 'lodash'
export default {
  name: 'SearchForm',
  components: {
    AutocompleteAirport,
    CountrySettings,
    Passengers,
    PassengersSelect,
    Residents,
    PromoCode,
    'FlightTypeSelect': FlightType,
    FlightTypeRadio,
    DatepickerController
  },
  inject: ['deviceType', '$validator'],
  props: {
    bookingData: {
      required: true,
      type: Object
    },
    showSimpleForm: {
      required: false,
      default: false,
      type: Boolean
    },
    customUrls: {
      required: false,
      type: Object
    },
    selectedSearchData: {
      type: Object,
      required: false
    },
    renderSpa: {
      type: String,
      required: false,
      default: null
    },
    searchIcon: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      mutationCount: 0,
      countrySetting: '',
      origin: '',
      destination: '',
      promoCodeValue: '',
      dateRange: null,
      passengers: '',
      startDate: null,
      dates: null,
      prePassengersSelected: null,
      isDoubleDatepicker: false,
      passengerComponent: 'passengers',
      flightTypeComponent: 'flight-type',
      widgetSetup: null,
      bookingSetup: null,
      showInputLabels: false,
      showTitles: false,
      residentData: {},
      elegibility: { resident: '', numerousFamily: '' },
      checkApiElegibility: false,
      elegibilityValues: [],
      autoOpenFirstDatePicker: false,
      countrySettingsFiltered: [],
      fixedPos: 0,
      airports: [],
      flightTypeSelected: null,
      fares: {},
      currency: ''
    }
  },
  watch: {
    disabledDatepicker: function () {
      if (this.disabledDatepicker) {
        this.dates = null
        this.dateRange = null
      } else {
        this.getDatesAvailable()
      }
    },
    isMulticity: function (isMulticity) {
      if (isMulticity) {
        this.$router.push({ name: 'multicity' })
      }
    },
    passengers: {
      handler (value) {
        this.prePassengersSelected = value
      }
    }
  },
  mounted () {
    this.pointOfSale = pos.init()
    // this.webAssemblyTokenHandler()
    document.querySelectorAll('.v-dropdown-container')[0].id = 'originDropdownContainer'
    document.querySelectorAll('.v-dropdown-container')[1].id = 'destinationDropdownContainer'

    const roundtripFromMulticitySetted = this.$store.getters.getRoundtripFromMulticity
    if (this.showMulticityFlow && roundtripFromMulticitySetted) {
      this.flightTypeSelected = 'round_trip'
      this.$store.commit('setRoundtripFromMulticity', false)
    }
  },
  beforeMount () {
    this.getAirports()
    this.handleSearchBeforeSelected()
  },
  methods: {
    /* No se uso, pero puede servir, lo dejo
    getDatesFromTo(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        var stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
            dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
            currentDate = moment(currentDate).add(1, 'days');
        }
        return dateArray;
    },
    generateDayRange() {
      const dates = this.getDatesFromTo(moment(), moment().add(6,'M'))
      const datesObj = {
        ow: dates,
        rt: dates
      }
      return datesObj
    },
    */
    async getFaresCurrency () {
      try {
        let data = await fetch(`${this.$store.getters.getConfigUrls.persistenceUrl}/get-currencies`)
        data = await data.json()
        this.currency = data.currencies[this.showFares.toLowerCase()]
      } catch (error) {
        console.error('error getting fares currency: ' + error)
      }
    },
    async getFares () {
      let [ratesOW, ratesRT] = await Promise.all([
        fetch(`${this.$store.getters.getConfigUrls.persistenceUrl}/rates?&airline_id=${this.showFares}&origin=${this.origin}&destination=${this.destination}&flight_type=OW`),
        fetch(`${this.$store.getters.getConfigUrls.persistenceUrl}/rates?&airline_id=${this.showFares}&origin=${this.origin}&destination=${this.destination}&flight_type=RT`)
      ])
      let fares = []

      if (ratesRT.status === 200) {
        ratesRT = await ratesRT.json()
        fares = ratesRT
      }

      if (ratesOW.status === 200) {
        ratesOW = await ratesOW.json()
        fares = [...fares, ...ratesOW]
      }

      if (fares.length) {
        this.fares = fares.reduce((acc, e) => {
          acc[this.$moment(e.date).format('DD/MM/YYYY')] = e.fare

          return acc
        }, {})
      }
    },
    onFlightTypeChange () {
      if (!this.disabledDatepicker) {
        this.getDatesAvailable()
      }
      this.dateRange = null
      this.clearDatepicker()
    },
    getAirports () {
      var displayTarget = this.displayTarget
      var keysToShow = Object.keys(displayTarget).filter(e => displayTarget[e] === true)
      this.airports = Object.values(this.enabledRoutes.information)
        .map(e => ({
          airport: e,
          name: this.getAirportNameToShowV2(e, displayTarget, keysToShow)
        }))
      this.airports.sort((a, b) => {
        return a.airport.city.description < b.airport.city.description ? -1 : (a.airport.city.description > b.airport.city.description ? 1 : 0)
      })
    },
    getAirportNameToShowV2: function (x, displayTarget, keysToShow) {
      let res = []
      let description = []

      if (this.bookingData.searchParameters.findIndex(p => p.airport_code === x.code) >= 0) {
        x.description = `airport_name_${x.code}`
      }

      if (displayTarget.airport_name) description.push(`${this.$t(x.description).toUpperCase()}`)
      if (displayTarget.city_code) description.push(`${x.city.code}`)
      if (displayTarget.city_name) description.push(`${x.city.description}`)
      if (displayTarget.country_code) description.push(`(${x.city.country.code})`)
      if (displayTarget.country_name) description.push(`${x.city.country.description}`)
      if (displayTarget.airport_code) res.push(`${x.code} ${keysToShow.length > 1 ? '- ' : ''}`)
      res.push(description.join(description.length > 1 ? ', ' : ' '))
      return res.join('')
    },
    handleSearchBeforeSelected () {
      if (this.selectedSearchData) {
        this.origin = this.selectedSearchData.origin.substring(0, 3)
        this.destination = this.selectedSearchData.destination.substring(0, 3)
        this.dateRange = moment(this.selectedSearchData.departure_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.flightTypeSelected = this.selectedSearchData.return_date ? 'round_trip' : 'one_way'
        if (this.selectedSearchData.return_date) {
          this.dateRange = [
            moment(this.selectedSearchData.departure_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            moment(this.selectedSearchData.return_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
          ]
        }
        this.countrySetting = this.selectedSearchData.country_setting
        this.promoCodeValue = this.selectedSearchData.promo_code
        this.prePassengersSelected = {
          counts: {
            adt: this.selectedSearchData.adults,
            chd: this.selectedSearchData.minors,
            inf: this.selectedSearchData.infants
          },
          cabin: this.selectedSearchData.cabin
        }
        this.mutationCount = +1
        this.elegibilityValues = this.selectedSearchData.elegibilityValues
      } else {
        let searchData = this.$store.getters.getSearchData
        if (searchData) {
          this.origin = this.getOriginAirports.find(i => i.airport.code === searchData.origin) ? searchData.origin : ''
          this.destination = this.getDestinationAirports.find(i => i.airport.code === searchData.destination) ? searchData.destination : ''
        }
      }
    },
    // webAssemblyTokenHandler () {
    //   let fetchPolifill = () => {
    //     let wasmPolyfillScript = document.createElement('script')
    //     wasmPolyfillScript.setAttribute('crossorigin', 'anonymous')
    //     wasmPolyfillScript.setAttribute('src', 'https://polyfill.io/v3/polyfill.min.js?features=blissfuljs%2Cdefault%2Ces2015%2Ces2016%2Ces2017%2Ces2018%2Ces5%2Ces6%2Ces7%2CBlob%2CArray.prototype.forEach')
    //     document.body.appendChild(wasmPolyfillScript)
    //   }
    //   let fetchWasmJs = async () => {
    //     var wUrl = `${window.location.protocol}//${window.location.host}/wasm/`
    //     axios.get(`${wUrl}void.js`).then(res => {
    //       let wasmScript = document.createElement('script')
    //       wasmScript.innerHTML = res.data
    //       document.body.appendChild(wasmScript)
    //       window.validateForm = Module.cwrap("validateForm", "string", ["string"])
    //     })
    //   }
    //   axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
    //   window.navigator.userLanguage = this.$i18n.locale
    //   fetchPolifill()
    //   fetchWasmJs()
    // },
    clearDatepicker: function () {
      if (this.$refs.datepicker.departure) {
        this.$refs.datepicker.departure = null
        this.$refs.datepicker.arrival = null
      }
    },
    /*
    getAirportNameToShow: function (x, inputField, displayTarget, keysToShow) {
      let res = []
      let description = []
      if (displayTarget.airport_name) description.push(`${this.$t(x[inputField].description).toUpperCase()}`)
      if (displayTarget.city_code) description.push(`${x[inputField].city.code}`)
      if (displayTarget.city_name) description.push(`${x[inputField].city.description}`)
      if (displayTarget.country_code) description.push(`(${x[inputField].city.country.code})`)
      if (displayTarget.country_name) description.push(`${x[inputField].city.country.description}`)
      if (displayTarget.airport_code) res.push(`${x[inputField].code} ${keysToShow.length > 1 ? '- ' : ''}`)
      res.push(description.join(description.length > 1 ? ', ' : ' '))
      return res.join('')
    },
    filterAirports: function (inputField) {
      let results = []
      let codes = []
      let allowedRoutes = this.bookingData.routes
      var displayTarget = this.displayTarget
      var keysToShow = Object.keys(displayTarget).filter(e => displayTarget[e] === true)
      let oppositeField = inputField === 'origin' ? 'destination' : 'origin'
      if (this[oppositeField]) {
        allowedRoutes = allowedRoutes.filter(x => x[oppositeField].code === this[oppositeField])
      }
      allowedRoutes.forEach(x => {
        if (this.bookingData.searchParameters.findIndex(p => p.airport_code === x[inputField].code) >= 0) {
          x[inputField].description = `airport_name_${x[inputField].code}`
        }
        let airport = {
          name: this.getAirportNameToShow(x, inputField, displayTarget, keysToShow),
          airport: x[inputField]
        }
        if (!codes.includes(x[inputField].code)) {
          results.push(airport)
          codes.push(x[inputField].code)
        }
      })
      return results.sort((a, b) => {
        return a.airport.city.description < b.airport.city.description ? -1 : (a.airport.city.description > b.airport.city.description ? 1 : 0)
      })
    },
    */
    submit: function (e) {
      e.preventDefault()
      if (this.isRoundTrip && (!this.dateRange || !this.dateRange[0] || !this.dateRange[1])) {
        this.dateRange = null
      }
      let trips = {}
      this.$validator.validateAll().then(result => {
        if (result) {
          trips.departure = this.isRoundTrip ? this.dateRange[0] : this.dateRange
          trips.return = this.isRoundTrip ? this.dateRange[1] : null
          let search = {
            departure_date: trips.departure,
            origin: this.origin,
            destination: this.destination,
            adults: this.passengers.counts.adt,
            minors: this.passengers.counts.chd,
            infants: this.passengers.counts.inf,
            cabin: this.passengers.cabin !== 'all_cabins' ? this.passengers.cabin : '',
            country_setting: this.countrySetting,
            return_date: trips.return,
            session_key: this.$store.getters.getSessionId,
            device_browser: this.pointOfSale.name,
            device_model: '???',
            device_id: '???',
            device_branding: '???',
            device_os_system_version: this.pointOfSale.os.version,
            device_os_system: this.pointOfSale.os.name,
            agent_preferred_language: navigator.language || navigator.userLanguage,
            device_category: window.mobilecheck() ? 'MOBILE' : 'DESKTOP',
            promo_code: this.promoCodeValue,
            eligibility: this.elegibilityKey
          }
          // search.state = this.$store.state
          this.$store.commit('setLoading', true)
          var url = this.getApiUrl(true)
          axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
          const payload = Object.assign({ state: this.$store.state }, search)
          this.setElegibilityFlowDiscount()
          this.setSearchDataAfterPost(search)
          this.pushDataLayer(search)
          axios.post(`${url}/action/`, payload).then((json) => {
            if (this.renderSpa) {
              this.$store.dispatch('goToSpa', this.renderSpa)
            } else {
              const searchParams = new URLSearchParams(window.location.search)
              const params = Object.fromEntries(searchParams.entries())
              this.$store.dispatch('goOutsideIframe', { query: params })
            }
          }).catch((error) => {
            console.log('error spa Bakend ' + error)
            this.$store.commit('setLoading', false)
          })
        } else {
          this.$store.commit('setLoading', false)
        }
      })
    },
    getApiUrl (searchForm = false) {
      let apiBookingVersion = 'v1'
      if (searchForm) {
        apiBookingVersion = get(this.$store.getters, 'getApiVersion', 'v1')
      }
      let path = 'searchflight/api/' + apiBookingVersion
      return (this.customUrls ? this.customUrls.base + path : this.$store.getters.getConfigUrls.apiBaseUrl + path)
    },
    validateFixedPos: function () {
      this.fixedPos = 0
      if (this.bookingData.route_pos_assign_data) {
        const fixedPos = this.bookingData.route_pos_assign_data

        let allFixed = fixedPos.find(route => route.origin === '' &&
              route.destination === '')
        let allOriginFixed = fixedPos.find(route => route.origin === '' &&
              route.destination === this.destination)
        let allDestinationFixed = fixedPos.find(route => route.origin === this.origin &&
              route.destination === '')

        let result = fixedPos.find(route => route.origin === this.origin &&
              route.destination === this.destination)

        this.fixedPos = 0

        if (result) {
          // El origen y destino seleccionado tienen fijo un pos
          this.fixedPos = result.pos
          this.countrySettingsFiltered = [this.bookingData.countrySettings.find(pos => pos.id === this.fixedPos)]
        } else if (allOriginFixed) {
          // Todos los origenes y el destino seleccionado tienen fijo un pos
          this.fixedPos = allOriginFixed.pos
          this.countrySettingsFiltered = [this.bookingData.countrySettings.find(pos => pos.id === this.fixedPos)]
        } else if (allDestinationFixed) {
          // Todos los destinos y el origen seleccionado tienen fijo un pos
          this.fixedPos = allDestinationFixed.pos
          this.countrySettingsFiltered = [this.bookingData.countrySettings.find(pos => pos.id === this.fixedPos)]
        } else if (allFixed) {
          // Todos los origenes y destinos tienen fijo un pos
          this.fixedPos = allFixed.pos
          this.countrySettingsFiltered = [this.bookingData.countrySettings.find(pos => pos.id === this.fixedPos)]
        } else {
          this.countrySettingsFiltered = this.bookingData.countrySettings
        }
        if (this.countrySettingsFiltered[0] == null) {
          this.countrySettingsFiltered = this.bookingData.countrySettings
          this.fixedPos = 0
        }
      }
    },
    getDatesAvailable: function () {
      this.errors.clear()
      this.validateFixedPos()
      this.$nextTick(async () => {
        const datePickerEl = document.querySelector('.--has-fancy')
        const progress = document.createElement('div')
        const indeterminate = document.createElement('div')
        progress.classList.add('fancyProgress')
        indeterminate.classList.add('indeterminate')
        progress.appendChild(indeterminate)
        datePickerEl.appendChild(progress)
        if (this.showFares) await this.getFares()
        var url = this.getApiUrl()
        axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
        axios({
          method: 'get',
          url: `${url}/dates/`,
          params: {
            origin: this.origin,
            destination: this.destination,
            is_round_trip: this.isRoundTrip ? 1 : 0
          }
        })
          .then((response) => {
            this.dates = response.data.response
            this.$store.commit('setDates', this.dates)
            this.autoOpenFirstDatePicker = true
          })
          .catch((e) => {
            console.log('error api get dates', e)
          })
          .finally(() => {
            document.querySelector('.--has-fancy .fancyProgress').remove()
          })
      })
    },
    loadWidgetSetup: function () {
      this.widgetSetup = this.$store.getters.getGeneralSettings.ecommerce_setup.widget_setup
      if (this.widgetSetup) {
        this.flightTypeComponent = (this.widgetSetup.journey_component.toLowerCase()).replace('1- ', '')
        this.passengerComponent = (this.widgetSetup.passenger_component.toLowerCase()).replace('1- ', '')
        this.isDoubleDatepicker = !this.widgetSetup.simple_datepicker
        this.showInputLabels = this.widgetSetup.show_input_labels
        this.showTitles = this.widgetSetup.widget_group_title
      }
    },
    loadBookingSetup: function () {
      this.bookingSetup = this.$store.getters.getGeneralSettings.booking_setup
      if (this.bookingSetup) {
        this.checkApiElegibility = this.bookingSetup.eligibility_programs_applicable_channels.includes('W')
      }
    },
    setElegibilityFlowDiscount: function () {
      this.$store.commit('setElegibility', {
        flowDiscount: (this.elegibility.resident != '' || this.elegibility.numerousFamily != ''),
        documentsFiltered: this.elegibility.documentsFiltered,
        resident: this.elegibility.resident,
        numerousFamily: this.elegibility.numerousFamily
      })
    },
    setSearchDataAfterPost: function (search) {
      search.departure_date = moment(search.departure_date).format('DD/MM/YYYY')
      search.return_date = search.return_date ? moment(search.return_date).format('DD/MM/YYYY') : null
      search.return_flight = !!search.return_date
      search.elegibilityValues = [
        {
          label: 'elegibility_resident',
          value: this.elegibility.resident
        },
        {
          label: 'elegibility_numerous_family',
          value: this.elegibility.numerousFamily
        }
      ]
      this.$store.commit('setSearchData', search)
    },
    destinationOriginOrCountrySettingChange () {
      if (this.origin && !this.destination) {
        this.$nextTick(() => document.querySelector("input[name='destination']").focus())
      }

      if (this.checkApiElegibility && this.destination && this.origin) {
        this.getEligibility()
      }
    },
    getEligibility: debounce(function () {
      const url = this.getApiUrl()
      const search = {
        origin: this.origin,
        destination: this.destination,
        point_of_sale: this.countrySetting
      }

      axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
      axios.post(`${url}/eligibility_setup/`, search).then((json) => {
        if (!json.data.response.data) { throw json }
        this.residentData = json.data.response.data
      })
        .catch(error => {
          this.residentData = {}
          console.log(error)
        })
    }, 500),
    setResidentNumerousFamilyData: function (value) {
      this.elegibility = value
    },
    pushDataLayer: function (search) {
      try {
        let GTMCode = this.$store.getters.getGTMCode
        if (GTMCode && GTMCode !== 'N' && window.dataLayer) {
          let typeOfJourney = search.return_date ? 'RT' : 'OW'
          const data = {
            'event': 'search_flight',
            'session_id': this.$store.getters.getSessionId,
            'trip_type': typeOfJourney,
            'origin': search.origin,
            'destination': search.destination,
            'qty_adt': search.adults,
            'qty_chd': search.minors,
            'qty_inf': search.infants,
            'pos': search.country_setting.device_id,
            'currency': search.country_setting.currency_code,
            'elegibility_code': search.eligibility,
            'promo_code': search.promo_code,
            'start_date': search.departure_date,
            'end_date': search.return_date,
            'carrier': this.$store.getters.getCarrier
          }
          console.table(data)
          window.dataLayer.push(data)
          delete data.event
          delete data.session_id
          this.$store.commit('setGASearchFlight', data)
        }
      } catch (error) {
        console.log('error pushing data layer: ' + error)
      }
    }
  },
  computed: {
    displayTarget: function () {
      let deviceType = this.deviceType
      return this.bookingData.display_logics.find(x => x.device_type.toUpperCase() === deviceType)
    },
    isRoundTrip: function () {
      return this.flightTypeSelected?.isRoundtrip
    },
    isMulticity: function () {
      return this.flightTypeSelected?.isMulticity
    },
    /*
    origins: function () {
      return this.filterAirports('origin')
    },
    destinations: function () {
      return this.filterAirports('destination')
    },
    */
    disabledDatepicker: function () {
      return !(this.origin && this.destination)
    },
    elegibilityKey: function () {
      let elegibility = []
      if (!this.elegibility.resident && !this.elegibility.numerousFamily) {
        return undefined
      }
      if (this.elegibility.resident) {
        elegibility.push(this.elegibility.resident)
      }
      if (this.elegibility.numerousFamily) {
        elegibility.push(this.elegibility.numerousFamily)
      }
      return elegibility
    },
    enabledRoutes () {
      return this.bookingData.enabledRoutes
    },
    getOriginAirports () {
      let results = []
      if (this.destination && this.enabledRoutes.return[this.destination]) {
        results = this.enabledRoutes.return[this.destination]
          .map(route => this.airports
            .find(({ airport }) => airport.code === route))
      } else {
        const airportKey = Object.keys(this.enabledRoutes.outgoin)
        results = this.airports.filter(value => airportKey.includes(value.airport.code))
      }
      return results.sort((a, b) => {
        return a.airport.city.description < b.airport.city.description ? -1 : (a.airport.city.description > b.airport.city.description ? 1 : 0)
      })
    },
    getDestinationAirports () {
      let results = []
      if (this.origin && this.enabledRoutes.outgoin[this.origin]) {
        results = this.enabledRoutes.outgoin[this.origin]
          .map(route => this.airports
            .find(({ airport }) => airport.code === route))
      } else {
        const airportKey = Object.keys(this.enabledRoutes.return)
        results = this.airports.filter(value => airportKey.includes(value.airport.code))
      }

      return results.sort((a, b) => {
        return a.airport.city.description < b.airport.city.description ? -1 : (a.airport.city.description > b.airport.city.description ? 1 : 0)
      })
    },
    showMulticityFlow: function () {
      return this.$store.getters.getGeneralSettings.ecommerce_setup?.enable_multicity_searches
    },
    showFares () {
      const seoBoosterId = this.$store.getters.getGeneralSettings.ecommerce_setup?.seo_booster_id
      const persistenceUrl = this.$store.getters.getConfigUrls.persistenceUrl
      if (seoBoosterId === 'NO' || !persistenceUrl) return false
      return seoBoosterId
    }
  },
  created () {
    this.loadWidgetSetup()
    this.loadBookingSetup()
    this.countrySettingsFiltered = this.bookingData.countrySettings
    this.flightTypeSelected = this.bookingData.oneWayDefault ? 'one_way' : 'round_trip'
    if (this.showFares) this.getFaresCurrency()
  }
}
</script>
<style lang="sass">
.searchForm
  position: relative
  display: flex
  flex-direction: column
  &__flightType
    order: 0
  &__paxs, &__OD, &__datepicker
    display: flex
    flex-direction: column
    width: 100%
  &__subtitle
    width: 100%
    font-size: var(--font-size-md)
    margin: 0 0 1.25rem
    font-weight: bolder
    padding-right: 1rem
    line-height: 1.4
    flex-basis: 100%
    &.--OD
      order: 3
    &.--pax
      order: 7
    &.--date
      order: 5
  &__paxs
    order: 7
    width: calc(50% - .25rem)
    margin-right: .5rem
    &.--paxsSelect + .searchForm__searchBtn
      width: 100%
    &.--paxsSelect
      width: 100%
    .fake_label
      display: none
  &__OD
    order: 4
    &Container
      display: flex
      flex-wrap: wrap
  &__datepicker
    order: 6
  &__form
    position: relative
    display: flex
    flex-wrap: wrap
    .--void
      display: none
      width: 100%
  &__searchBtn
    width: calc(50% - .5rem)
    order: 8
    .btn
      display: flex
      justify-content: center
      align-items: center
      flex: 1
      width: 100%
      height: 3rem
      margin-bottom: 1rem
    .btn:hover
      text-decoration: none
  &__flightType
    width: 100%
  .passengersComponent
    width: 100%
  .promoCode
    order: 9
    flex-basis: calc(50% - .5rem)
    margin-right: 0
  .countrySettings
    order: 10
    flex-basis: calc(50% - .5rem)
    margin-right: 1rem
@media (min-width: 992px)
  .searchForm
    margin-bottom: 0
    &__subtitle
      order: initial !important
      &.--OD
        flex-basis: 40%
      &.--date
        flex-basis: 30%
      &.--pax
        flex-basis: 25%
    &__OD
      max-width: 40%
    &__datepicker
      flex-basis: 30%
      margin-right: .5rem
    &__paxs
      flex-basis: 72px
      margin: 0
      .fake_label
        display: block
    &__form
      .--void
        display: block
    &__searchBtn
      max-width: calc(25% - 72px)
      margin-left: .5rem
      flex: 1
      display: flex
      &.--formLabeled
        padding-top: 27px
    &__flightType
      width: auto
      flex-basis: auto
    .passengersComponent
      max-width: 76px
      margin-right: 0
    .promoCode, .countrySettings
      width: auto
      flex-basis: auto
      margin-right: .5rem
    .promoCode
      order: initial
    .countrySettings
      order: initial
</style>
